import { takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { SupportActions } from '@app/_store';
import { Subject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-support-email-dialog',
  templateUrl: './support-email-dialog.component.html',
  styleUrls: ['./support-email-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, NgIf],
})
export class SupportEmailDialogComponent implements OnDestroy {
  componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  isSending: boolean;
  body: string;

  constructor(
    public activeModal: NgbActiveModal,
    private store: Store
  ) {}

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  send(): void {
    this.isSending = true;
    this.store
      .dispatch(new SupportActions.SendSupportEmail(this.body))
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(() => {
        this.activeModal.dismiss();
      });
  }
}
